import { useEffect, useRef, useState } from 'react'
import './player-home-content.styles.scss'
import { useSelector } from 'react-redux'
import PlayerStatusTable from './components/status-table.component'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRankingStar } from '@fortawesome/free-solid-svg-icons'
import gem from '@/assets/icons/xp.png'
import coin from '@/assets/icons/coin.png'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'
import { stripHtml } from '@/utils/sanitize'
import { properCase } from '@/utils/properCase'
import { Link, useNavigate } from 'react-router-dom'
import Modal from '@/components/modal/modal.component'
import linkifyHtml from 'linkify-html'
import { format } from 'date-fns'
import { checkElementAccess } from '@/utils/checkElementAccess'

const PlayerHomeContent = ({
  gameData,
  playerData,
  gameElements,
  playerActivity,
  playerList,
  latestMessage,
  teamMembers
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [currentRank, setCurrentRank] = useState(null);
  const [totalPlayers, setTotalPlayers] = useState(0);
  const [statusHeight, setStatusHeight] = useState(0);
  const [featuredElement, setFeaturedElement] = useState(null);
  const [showGameInfo, setShowGameInfo] = useState(false);
  const [messageHeight, setMessageHeight] = useState(100);
  const timeoutRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    const box = document.querySelector('.card5');
    if (box) {
      const height = box.offsetHeight;
      setStatusHeight(height - 75);
    }
    // findMessageHeight();
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    }
  }, [])

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      findMessageHeight();
    }, 1500);
  }, [featuredElement])

  useEffect(() => {
    if (!gameData || !playerData || !gameElements) return;
    const pageTitle = document.getElementById('page-title');
    if (pageTitle) {
      pageTitle.innerText = 'Game Home'
    }
    const availableElements = Object.values(gameElements)
      .filter(e =>
        checkElementAccess({
          'playerData': playerData,
          'gameElements': gameElements,
          'elementId': e.id,
          'teamMembers': teamMembers,
          'type': e.type,
          'bool': true
        })
      )
      .filter(e => e.type !== 'secretCode');
    // console.log(availableElements);
    if (gameData.featuredElement && availableElements.filter(e => e.id === gameData.featuredElement).length > 0) {
      setFeaturedElement(gameElements[gameData.featuredElement]);
    } else {

      const num = Math.floor(Math.random() * Object.values(gameElements)
        .filter(e => checkElementAccess({
          'playerData': playerData,
          'gameElements': gameElements,
          'elementId': e.id,
          'teamMembers': teamMembers,
          'type': e.type,
          'bool': true
        })).length);
      // console.log(num);
      let elem = availableElements[num];
      setFeaturedElement(elem);
    }
  }, [gameData, playerData, gameElements])

  useEffect(() => {
    if (!gameData || !playerList || !playerData) return;
    const sort = gameData.sortLeaders ?? 'points';
    let sortedPlayers = Object.values(playerList)
      .filter(p => !p.playerId.includes('_team'))
      .sort((a, b) =>
        b[sort] !== a[sort]
          ? b[sort] - a[sort]
          : (a.displayName ?? '').toLowerCase() < (b.displayName ?? '').toLowerCase() ? 1 : -1
      )
      .map(p => p.playerId);
    setCurrentRank(sortedPlayers.includes(playerData.playerId) ? sortedPlayers.indexOf(playerData.playerId) + 1 : 0);
    setTotalPlayers(sortedPlayers.length)
  }, [gameData, playerList, playerData])

  function findMessageHeight() {
    const featuredCard = document.getElementById('featured-card');
    if (!featuredCard) return;
    const cardHeight = featuredCard.offsetHeight;
    const featuredDiv = document.getElementById('featured-item');
    const featuredHeight = featuredDiv ? featuredDiv.offsetHeight : 400;
    // console.log(featuredHeight);
    setMessageHeight(cardHeight - featuredHeight - 126);
  }

  return (
    <div className='player-home-container'>
      <div className={`player-home-content ${screenSize}`}>
        <div className='g-card card1 game-title'>
          <ImageContainer
            src={gameData.icon}
            className={`icon ${gameData.border_icon}-border`} />
          <div className='title-box'>
            <div className='welcome'>Welcome to</div>
            <div className='title'>{gameData.gameName}</div>
          </div>
          <div className='button-box'>
            <button className='g-button small-btn' onClick={() => setShowGameInfo(true)}>Game<br />Info</button>
          </div>
        </div>
        {
          (!gameData.sortLeaders || gameData.sortLeaders === 'points')
            ?
            <Link to={`/play/${gameData.path}/xp`} className={`g-card card2 data-box ${screenSize} clickable`} >
              <div className='icon-circle'>
                <img src={gem} />
              </div>
              <div className='data-div'>
                <div className='data-number'>
                  {playerData.points ? playerData.points.toLocaleString() : '0'}
                </div>
                <div className='data-text'>
                  Your XP
                </div>
              </div>

            </Link>
            :
            (gameData.sortLeaders === 'currency')
              ?
              <Link to={`/play/${gameData.path}/currency`} className={`g-card card2 data-box ${screenSize} clickable`} >
                <div className='icon-circle'>
                  <img src={coin} />
                </div>
                <div className='data-div'>
                  <div className='data-number'>
                    {playerData.currency ? playerData.currency.toLocaleString() : 0}
                  </div>
                  <div className='data-text'>
                    Your Available Currency
                  </div>
                </div>
              </Link>
              :
              <div className='g-card card2 data-box'>

              </div>
        }
        {
          (gameData.access.includes('leaderboards'))
            ?
            <Link to={`/play/${gameData.path}/leaderboards`} className={`g-card card3 data-box ${screenSize} clickable`} >
              <div className='icon-circle'>
                <FontAwesomeIcon icon={faRankingStar} size='xl' />
              </div>
              <div className='data-div'>
                <div className='data-number'>
                  {currentRank ? <span>#{currentRank} <span className='meta'>of {totalPlayers}</span></span> : 0}
                </div>
                <div className='data-text'>
                  Current Rank
                </div>
              </div>
            </Link>
            :
            <div className={`g-card card3 data-box ${screenSize}`}>
              <div className='icon-circle'>
                <FontAwesomeIcon icon={faRankingStar} size='xl' />
              </div>
              <div className='data-div'>
                <div className='data-number'>
                  {currentRank ? <span>#{currentRank} <span className='meta'>of {totalPlayers}</span></span> : 0}
                </div>
                <div className='data-text'>
                  Current Rank
                </div>
              </div>
            </div>
        }

        <div className='g-card card4' id='featured-card'>

          <div id="featured-item">
            <div className='card-title'>Featured</div>
            <div className="g-space-1"></div>
            {
              (featuredElement)
                ?
                <div
                  className={`featured-element g-list-item ${featuredElement.type === 'challenge' ? 'clickable with-shadow' : ''}`}
                  onClick={featuredElement.type === 'challenge' ? () => navigate(`challenges/${featuredElement.path}`) : null}
                >
                  <ImageContainer src={featuredElement.icon} alt={`${featuredElement.name} ${featuredElement.type} icon`} className='featured-element-icon' />
                  <div className='featured-element-info'>
                    <div className='title'>
                      {featuredElement.name}
                    </div>
                    <div className='meta'>{properCase(featuredElement.type)}</div>
                    <div className='desc'>{featuredElement.desc ? stripHtml(featuredElement.desc).length > 90 ? `${stripHtml(featuredElement.desc).substring(0, 90)}...` : stripHtml(featuredElement.desc) : ''}</div>
                  </div>
                </div>
                :
                <div className='no-featured'>
                  No featured item at this time. Check back later!
                </div>
            }
          </div>

          {
            (latestMessage) &&
            <div className='message-container'>
              <div className='g-space-2'></div>
              <div className='card-title'>Latest News</div>
              <div className="g-space-1"></div>
              <div className='g-list-item message-box' style={{ 'height': messageHeight + 'px' }}>
                {
                  (latestMessage.title) &&
                  <div className='headline'>{latestMessage.title}</div>
                }
                <div className='meta'>Posted {format(new Date(latestMessage.ts), "Pp")}</div>
                <div dangerouslySetInnerHTML={{ __html: linkifyHtml(latestMessage.message, { 'target': '_blank' }) }} ></div>
              </div>
            </div>
          }
        </div>
        <div className='g-card card5'>
          <div className='card-title'>Player Status</div>
          <div className="g-space-1"></div>
          <div className='status-box' style={{ 'height': statusHeight }}>
            <PlayerStatusTable gameData={gameData} playerData={playerData} gameElements={gameElements} playerActivity={playerActivity} />
          </div>
        </div>
      </div>

      <Modal show={showGameInfo} cancel={() => setShowGameInfo(false)} closeButton={true} cls='narrow' text='Game Information' >
        <div className='modal-children'>
          {
            (gameData.desc) &&
            <div dangerouslySetInnerHTML={{ __html: linkifyHtml(gameData.desc) }}></div>
          }
          <div className="g-space-1"></div>
          <div className='buttons'>
            <div className='g-button' onClick={() => setShowGameInfo(false)}>Ok</div>
          </div>
        </div>
        
      </Modal>

    </div>
  )
}

export default PlayerHomeContent